import { Component, OnInit, ViewChild, HostListener, PLATFORM_ID, Inject, PendingTasks } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import * as globalConstant from '../../global_constant';
import { MainService } from 'src/app/main.service';
import { RegisterService } from 'src/app/services/Register.service';
import { CharityService } from 'src/app/services/Charity.service';
import { debounce, debounceTime } from 'rxjs/operators';
import { of, timer, Subject, forkJoin } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Experience } from 'src/app/services/experience.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { SharedModule } from '../../share/shared.module';
import { CanonicalService } from 'src/app/services/canonical.service';
import { CmsContentService } from 'src/app/services/CmsContent.service';
import { CmsPageSeoService } from 'src/app/services/cms-page-seo.service';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';


declare var $: any;

@Component({
	selector: 'app-charity',
	standalone: true,
	providers: [
		{ provide: ToastrService, useClass: ToastrService }
	],
	imports: [
		SharedModule,
		NgxSkeletonLoaderModule
	],
	templateUrl: './charity.component.html',
	styleUrls: ['./charity.component.css']
})
export class CharityComponent implements OnInit {

	@ViewChild('experienceDetailsPopup', { static: false }) public experienceDetailsPopup: ModalDirective;
	errors: any;
	category_data: any;
	charities_data: any = [];
	search_text: any;
	submitted = false;
	loading = false;
	image_url = '';
	charity_base_url = '';
	charites_url = '';
	show_category: boolean = false;
	show_charity: boolean = true;
	searched_data: any = [];
	search_string: any = '';
	token: any = "";
	modelChanged: Subject<string> = new Subject<string>();
	siteUrl: String = globalConstant?.WEBSITE_URL;

	authUser: any;
	fromPage: any = ''
	base_website_url: string = '';

	result: any;
	page_image_url = '';
	charity_detail_data: any;
	charity_detail_url = '';
	profile_url = '';
	isBrowser: boolean;
	onPopState(event) {
		close();
	}
	pageUrl: any = '';
	isPageReady = false;
	constructor(
		public datepipe: DatePipe,
		private canonicalService: CanonicalService,
		private cmsPageSeoService: CmsPageSeoService,
		private titleService: Title,
		private mainService: MainService,
		private charityService: CharityService,
		public router: Router,
		private experience: Experience,
		public toastr: ToastrService,
		private route: ActivatedRoute,
		private registerService: RegisterService,
		private metaService: Meta,
		public cmsContentService: CmsContentService,
		private pendingTasks: PendingTasks,
		@Inject(PLATFORM_ID) platformId: Object) {
		let currenturl = this.router.url;
		let componentUrl = currenturl.startsWith('/') ? currenturl.slice(1) : currenturl;
		const canonicalUrl = this.normalizeUrl(this.siteUrl + componentUrl);
		this.pageUrl = this.canonicalService.setCanonical(canonicalUrl);
		this.isBrowser = isPlatformBrowser(platformId);
		if (this.isBrowser) {

			if (typeof window !== 'undefined') {
				window.scrollTo(0, 0)
			}
		}
		// this.titleService.setTitle("Charity"+globalConstant.SITE_TITLE_SEPARATOR+globalConstant.SITE_TITLE);

		this.modelChanged.pipe(
			debounceTime(800))
			.subscribe(searchText => {
				this.search_string = searchText;
				this.searching(this.search_string)

			});
		if (this.isBrowser) {
			if (typeof localStorage !== 'undefined') {
				if (localStorage.getItem('authUser')) {
					this.authUser = JSON.parse(localStorage.getItem('authUser'));
					this.token = localStorage.getItem('login_token')
				}
			}
		}

		this.route.queryParams.subscribe(params => {
			this.fromPage = params['fromPage'] == undefined ? "" : params['fromPage'];

		});
		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				if (this.isBrowser) {

					document.querySelector("body").classList.remove("modal-open");
				}
			}
		});

	}

	normalizeUrl(url: string): string {
		return url.endsWith('/') ? url.slice(0, -1) : url; // Remove trailing slash if present
	}

	owlCharity = {
		animateOut: 'fadeOut',
		animateIn: 'fadeIn',
		mouseDrag: false,
		margin: 0,
		autoplayTimeout: 7000,
		transitionStyle: "fade",
		touchDrag: true,
		autoplay: true,
		lazyLoad: true,
		items: 1,
		smartSpeed: 500,
		nav: true,
		loop: true,
		dots: false,
		autoplayHoverPause: true,
		navText: ["<i class='fas fa-chevron-left cusLeft'></i>", "<i class='fas fa-chevron-right cusRight'></i>"],

	}

	ngOnInit() {
		this.loadInitialCharityPage();
		if (this.isBrowser) {
			if (typeof window !== 'undefined') {
				this.base_website_url = window.location.origin;
			}
		}
	}

	private loadInitialCharityPage(): void {
		let slug = this.router?.url?.split('/')[1]?.toString();
		if (slug == 'charities?fromPage=registry') {
			slug = slug?.split('?')[0];
		}
		const requestBody = {
			category_for: 'charity',
			type: 'charity-category',
		};
		this.isPageReady = false;
		const taskCleanup = this.pendingTasks.add();
		forkJoin({
			cms: this.cmsContentService.getCmsContent(slug),
			categories: this.mainService.get_categories(requestBody),
		})
			.pipe(finalize(() => taskCleanup()))
			.subscribe({
				next: ({ cms, categories }) => {
					this.result = cms?.data;
					this.page_image_url = cms?.image_url;
					this.addMetaTags();
					if (categories?.response == 'success') {
						this.category_data = categories.data;
						this.image_url = categories.image_url;
					}
					this.isPageReady = true;
				},
				error: () => {
					this.isPageReady = true;
				},
			});
	}

	ngAfterViewInit() {
		//   $('.magni-pop').magnificPopup({
		//     type: 'iframe'
		//   }); 
	}

	// Custom Magnific Popup
	videoPopup(event) {

		event.preventDefault();

		var videoUrl = event.target.href;
		var videoid = videoUrl.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/);
		if (this.isBrowser) {
			var veboBody = document.getElementById("vebo_body");

			veboBody.classList.add('videoPopup-hidden');

			var videoFarme = document.getElementById('videoIframe');

			var srcAttr = document.createAttribute("src");
			srcAttr.value = '//www.youtube.com/embed/' + videoid[1] + '?autoplay=1';
			videoFarme.setAttributeNode(srcAttr);

			document.getElementById('video-popup-wrapper').hidden = false;
		}

	}

	// Custom Magnific Popup End

	closeVideoPopup(event) {
		if (this.isBrowser) {
			var veboBody = document.getElementById("vebo_body");
			veboBody.classList.remove('videoPopup-hidden');
			document.getElementById('video-popup-wrapper').hidden = true;
			var videoFarme = document.getElementById('videoIframe');
			videoFarme.removeAttribute("src");
		}
	}

	searching(searchtext) {

		this.loading = true;
		this.search_text = searchtext;
		if (searchtext == "") {
			this.show_category = false;
			this.show_charity = true;
			this.loading = false;
		}
		else {
			this.show_category = true;
			this.show_charity = false;
			let requestBody = { "search": searchtext }
			this.charityService.get_charities(requestBody, this.token).subscribe(res => {

				if (res.response == "success") {
					this.charities_data = res.data;
					this.charites_url = res.charity_base_url;
					for (let i = 0; i < this.charities_data.length; i++) {
						this.searched_data.push(this.charities_data[i]);
					}
					this.loading = false;
				}
				else {
					this.loading = false;
				}
			});

		}

	}

	changed(search) {
		this.modelChanged.next(search);
	}
	onCharitiesBase(event) {
		if (event.target.checked) {
			this.show_category = true;
			this.show_charity = false;
			let requestBody = { "search": this.search_string, "show_as_state": '1' }
			this.charityService.get_charities(requestBody, this.token).subscribe(res => {

				if (res.response == "success") {
					this.charities_data = res.data;
					this.charites_url = res.charity_base_url;
					for (let i = 0; i < this.charities_data.length; i++) {
						this.searched_data.push(this.charities_data[i]);
					}
					this.loading = false;
				}
				else {
					this.loading = false;
				}
			});
		}
		else {
			this.show_category = false;
			this.show_charity = true;
			let requestBody = { "search": this.search_string, "show_as_state": '0' }
			this.charityService.get_charities(requestBody, this.token).subscribe(res => {

				if (res.response == "success") {
					this.charities_data = res.data;
					this.charites_url = res.charity_base_url;
					for (let i = 0; i < this.charities_data.length; i++) {
						this.searched_data.push(this.charities_data[i]);
					}
					this.loading = false;
				}
				else {
					this.loading = false;
				}
			});
		}
	}

	fb(e) {
		e.preventDefault();
		if (this.isBrowser) {
			if (typeof window !== 'undefined') {
				var facebookWindow = window.open(
					'https://www.facebook.com/sharer/sharer.php?u=' + this.base_website_url + '/charities&title=CHARITIES',
					'facebook-popup',
					'height=350,width=600'
				);
				if (facebookWindow.focus) {
					facebookWindow.focus();
				}
			}
			return false;
		}
	}
	pinterest(e) {
		e.preventDefault();
		if (this.isBrowser) {
			if (typeof window !== 'undefined') {
				var pinterestWindow = window.open(
					'http://pinterest.com/pin/create/bookmarklet/?media=url=' + this.base_website_url + '/charities&title=CHARITIES&is_video=false&description=charities',
					'pinterest-popup',
					'height=350,width=600'
				);
				if (pinterestWindow.focus) {
					pinterestWindow.focus();
				}
			}
			return false;
		}
	}
	twitter(e) {
		e.preventDefault();
		if (this.isBrowser) {
			if (typeof window !== 'undefined') {
				var twitterWindow = window.open(
					'http://twitter.com/intent/tweet?status=CHARITIES' + this.base_website_url + '/charities',
					'twitter-popup',
					'height=350,width=600'
				);
				if (twitterWindow.focus) {
					twitterWindow.focus();
				}
				return false;
			}
		}
	}

	charitySelection(charity_id, charity_title) {
		//localStorage.setItem('charity_id',charity_id)
		// let formData = new FormData()
		// formData.append('charity_choosed',charity_id)
		//formData.append('user_id',this.authUser.id);
		this.loading = true;
		let requestBoady = { 'charity_choosed': charity_id }
		this.registerService.register_couple_charity_step_6(requestBoady, this.token).subscribe(res => {
			if (res.response == "success") {
				if (this.isBrowser) {
					if (typeof localStorage !== 'undefined') {
						localStorage.setItem('authUser', JSON.stringify(res.data));
					}
					setTimeout(() => {
						this.loading = false;
						this.router.navigate(['profile'], { queryParams: { id: charity_id, title: charity_title } });
					}, 1000);
				}
			} else {
				this.loading = false;
				//this.toastr.errorToastr(res.message, 'Error!'); 
			}
		});

	}

	charity_detail(slug) {
		this.charity_detail_data = [];
		this.charity_detail_url = '';
		this.profile_url = '';
		this.loading = true;
		let requestBody = { "charity_slug": slug }
		this.charityService.get_charity(requestBody).subscribe(res => {
			if (res.response == "success") {
				if (this.isBrowser) {
					var element = document.querySelector("body");
					var htmlelement = document.querySelector("html")
					if (element) {
						element.classList.add('overflow');
					}
					if (htmlelement) {
						htmlelement.classList.add('overflow');
					}
					this.charity_detail_url = res.charity_base_url;
					this.profile_url = res.profile_image_url;
					this.charity_detail_data = res.data;
					this.loading = false;
					this.experienceDetailsPopup.show();
				}
			} else {
				this.loading = false;
			}
		});
	}


	owlCharityDetail = {
		mouseDrag: false,
		margin: 0,
		autoplayTimeout: 7000,
		transitionStyle: "slide",
		touchDrag: true,
		autoplay: true,
		lazyLoad: true,
		items: 1,
		smartSpeed: 500,
		nav: false,
		loop: true,
		dots: false,
		autoplayHoverPause: true,
	}
	close() {
		this.experienceDetailsPopup.hide();
	}

	addMetaTags() {
		const pageName = (this.result?.name || this.result?.title || 'Charities').trim();
		const description = this.cmsPageSeoService.resolveMetaDescription(
			this.result?.meta_description,
			'Support featured charities through Spur Experiences wedding registries and give back while celebrating.',
			pageName,
		);
		const siteRoot = (globalConstant.WEBSITE_URL || 'https://spurexperiences.com/').replace(/\/?$/, '/');
		this.cmsPageSeoService.applyCmsPageSeo({
			...this.result,
			title: pageName,
			name: pageName,
			meta_description: description,
		}, {
			pageUrl: this.pageUrl,
			schemaType: 'WebPage',
			documentTitle: 'Charities | Spur Experiences',
			breadcrumbs: [
				{ name: 'Home', url: siteRoot },
				{ name: 'Charities', url: this.pageUrl },
			],
		});
	}

}
